// extracted by mini-css-extract-plugin
export default {"input":"inputs_input__4W9pM"};